export default Object.assign({}, window.appGlobals, {

    apiBase: '/api/v1',

    defaultLocale: 'en',

    locales: {
        en: 'English',
        fr: 'Français',
        nl: 'Nederlands'
    },

    errorLevels: [
        'emergency',
        'alert',
        'critical',
        'error',
        'warning',
        'notice',
        'info',
        'debug',
    ],

    playlistStatusDefaultColor: 'debug',

    // {@see \App\Constants} for status explanation
    playlistStatusColorMap: {
        'pending': 'critical',
        'created': 'warning',
        'confirmed': 'notice',
        'partial_playout': 'info',
        'played': 'info',
    },

    // {@see \App\Constants} for status explanation
    playlistConfirmsColorMap: {
        'received': 'warning',
        'partial_playout': 'notice',
        'played': 'info',
    },

    // {@see \App\Constants} for status explanation
    playlistAvailabilityStatusColorMap: {
        'pending': 'warning',
        'failed' : 'error',
        'created': 'info',
    },

    movieMapping: {
        yearDiffThreshold: 2
    },

    // Max future date to create new movies with the MovieCreateForm plugin
    createMovieMaxFutureYears: 1,
})
